import { DecimalPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "defaultBlank",
})
export class DefaultBlankPipe implements PipeTransform {
    constructor(private decimalPipe: DecimalPipe) {}

    transform(
        value: any,
        type: "number" | "double" | "string" | "null" = "null",
        symbolInfo: {
            symbol?: string;
            position?: "before" | "after";
            format?: boolean;
        } = {
            symbol: "",
            position: "before",
            format: false,
        }
    ): any {
        const typeOf = type && type !== "null" ? type : typeof value;

        if (typeOf === "number") {
            const parsedValue = parseFloat(value);
            if (symbolInfo && (symbolInfo.symbol !== "" || symbolInfo.format)) {
                const decimalFormat = symbolInfo.format ? "1.0-2" : "1.0-0";
                const formattedValue = !isNaN(parsedValue)
                    ? (this.decimalPipe.transform(parsedValue, decimalFormat) as string)
                    : (this.decimalPipe.transform(0, decimalFormat) as string);

                if (symbolInfo.symbol && symbolInfo.position) {
                    return this.addSymbol(formattedValue, {
                        symbol: symbolInfo.symbol,
                        position: symbolInfo.position,
                    });
                }
                return formattedValue;
            }

            return !isNaN(parsedValue) ? parsedValue : 0;
        } else if (typeOf === "double") {
            const parsedValue = parseFloat(value);
            const formattedValue = !isNaN(parsedValue) ? parsedValue.toFixed(1) : (0).toFixed(1);
            if (symbolInfo.symbol && symbolInfo.position) {
                return this.addSymbol(formattedValue, {
                    symbol: symbolInfo.symbol,
                    position: symbolInfo.position,
                });
            }
            return formattedValue;
        } else if (typeOf === "string") {
            return ("" + value).trim() !== "" ? value : "---";
        } else {
            return "---";
        }
    }

    private addSymbol(value: string, symbolInfo: { symbol: string; position: "before" | "after" }): string {
        return symbolInfo.position === "before" ? symbolInfo.symbol + value : value + symbolInfo.symbol;
    }
}
